import { render, staticRenderFns } from "./ExportSotecDashboard.vue?vue&type=template&id=63f29ae0&scoped=true&"
import script from "./ExportSotecDashboard.vue?vue&type=script&lang=js&"
export * from "./ExportSotecDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f29ae0",
  null
  
)

export default component.exports